import WrapperProvider from "@providers/WrapperProvider";
import DiscoverContainer from "@containers/DiscoverContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import LocationCategoryService from "@services/LocationCategoryService";
import TourCategoryService from "@services/TourCategoryService";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <DiscoverContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel65-discover-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const resCategories = await LocationCategoryService.find({
    locale,
    populate: ["deep"],
    filters: {
      hotel: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
  });
  const resTourCategories = await TourCategoryService.find({
    locale,
    populate: ["deep"],
    filters: {
      hotel: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  return {
    hotel: "amanaki-boutique-saigon",
    pageData: _.get(res, "data", {}),
    locationCategories: _.get(resCategories, "data", []),
    tourCategories: _.get(resTourCategories, "data", []),
    footerData,
  };
});
